import VueRecaptcha from 'vue-recaptcha';
import ModalComponent from '@/components/Modal/Modal.vue';
import ModalWithoutApplicationComponent from '@/components/ModalWithoutApplication/ModalWithoutApplication.vue';
import ModalErrorComponent from '@/components/ModalError/ModalError.vue';
import ModalNetworkError from '@/components/ModalNetworkError/ModalNetworkError.vue';
import transferTracking from '@/api/transferTracking';
import recaptcha from '@/api/recaptcha';

export default {
  name: 'Home',
  components: {
    VueRecaptcha,
    ModalComponent,
    ModalWithoutApplicationComponent,
    ModalErrorComponent,
    ModalNetworkError,
  },
  data() {
    return {
      name: '',
      isLoading: false,
      inputRut: '',
      inputError: '',
      showModal: false,
      showModalWithoutApplication: false,
      showModalError: false,
      showModalNetworkError: false,
      result: null,
      captchaValidation: false,
      captchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
    };
  },
  computed: {
    isFormIncomplete() {
      return (!this.inputRut || !!this.inputError || !this.captchaValidation);
    },
  },
  methods: {
    getError(err) {
      this.inputError = err;
    },
    verifyCaptcha(token) {
      recaptcha.verifyCaptcha(token)
        .then((response) => {
          if (response.success && token != null) {
            this.captchaValidation = true;
          } else {
            this.captchaValidation = false;
            this.$refs.recaptcha.reset();
          }
        })
        .catch(() => {
          this.captchaValidation = false;
          this.$refs.recaptcha.reset();
        });
    },
    expireCaptcha() {
      this.captchaValidation = false;
      this.$refs.recaptcha.reset();
    },
    getData() {
      this.isLoading = true;

      transferTracking.getStatus(this.formatRut(this.inputRut))
        .then(this.handleTransferStatusSuccess)
        .catch(this.handleTransferStatusError)
        .finally(() => {
          this.inputRut = '';
          this.isLoading = false;
        });
    },
    formatRut(rut) {
      if (rut.includes('-')) {
        return rut;
      }

      return `${rut.substring(0, rut.length - 1)}-${rut.substring(rut.length - 1)}`;
    },
    handleTransferStatusSuccess(status) {
      const { message } = status;
      switch (message) {
        case 'NoTransferRequestsFound':
          this.showModalWithoutApplication = true;
          return;
        case 'ElectronicTransferRejected':
        case 'ElectronicTransferError':
          this.showModalError = true;
          this.name = status.clientName;
          return;
        case 'ElectronicTransferSuccessful':
        case 'ElectronicTransferAccepted':
          this.showStepsModal(status);
          return;
        default:
          this.showModalError = true;
          this.name = status.clientName;
      }
    },
    handleTransferStatusError() {
      this.showModalNetworkError = true;
    },
    showStepsModal(status) {
      this.result = status;
      this.name = status.clientName;
      this.inputRut = '';
      let stepsQuantity = 0;

      if (this.result.requestSteps.length > 0) {
        this.result.requestSteps.forEach((step) => {
          if (step.stepPassed) {
            stepsQuantity += 1;
          }
        });
      }

      if (stepsQuantity === 0) {
        this.showModalError = true;
      } else {
        this.showModal = true;
      }
    },
    closeModal() {
      this.showModal = false;
      this.showModalError = false;
      this.showModalWithoutApplication = false;
      this.showModalNetworkError = false;
      this.name = '';
      this.result = null;
    },
  },
};
